import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnUser } from '@lib/api/entities';
import { UserSearchDialogComponent } from '@lib/users/components/user-search-dialog';

import { FsPolicyGroupService } from '../../services';

@Component({
  selector: 'fs-policy-users',
  templateUrl: './policy-users.component.html',
  styleUrls: ['./policy-users.component.scss'],
})
export class PolicyUsersComponent implements OnInit, OnDestroy {
  @Input() public id: string;

  @Input() public canChange: boolean;

  public users: SnUser[] = [];
  public isLoading: boolean;

  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _policyGroupService: FsPolicyGroupService,
    private readonly _toastrService: ToastrService,
  ) {}

  public ngOnInit(): void {
    this.isLoading = true;
    this._policyGroupService
      .users(this.id, {
        pageSize: 'all',
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        this.users = response.results;
        this.isLoading = false;
        this._cdr.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public removeUser(i: number): void {
    this.users.splice(i, 1);
  }

  public addUsers(): void {
    const dialogRef = this._matDialog.open(UserSearchDialogComponent, {
      maxWidth: '90%',
      width: '960px',
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe((users) => {
        this.users.push(
          ...users.filter((u) => this.users.map((user) => user.id).indexOf(u.id) === -1),
        );
        this._cdr.detectChanges();
      });
  }

  public save(): void {
    this.isLoading = true;
    this._policyGroupService
      .setUsers(this.id, this.users)
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this.isLoading = false;
        this._toastrService.success('Users updated.');
        this._cdr.detectChanges();
      });
  }
}
